<template>
<div class="row pad-in" >

   <el-upload :action="action" ref="uploadFiles"  class="col s12"  style="padding-bottom:10px;" v-if="file.url==''"
   :file-list = "fileList" 
   :multiple="false" 
   drag
   :on-success="onSuccess"
   :on-error="onError"
   :on-exceed="onExceed"
   :before-upload="beforeUpload"
   :data="{dir:savedir,scriptError:'504 Errore lato server'}"
   :headers="{'X-Request-ID': this.$teras.name,'X-aes': false}"
   :show-file-list="false"
   >
   <div style="height:100px;" >
      <div class="yo-valign-center">
      <i class="material-icons " style="font-size:4.8rem;">cloud_upload</i>
      <div style="margin-top:4px;">Drop file document here or <span style="font-style:italic;">click to upload</span></div>
      </div>
   </div>
   </el-upload>

   <div class="col s12 " style="height:100px;border:1px dashed lightgrey;margin-bottom:10px;" v-if="file.url!=''">

   <div class="row" v-if="file.url!=''" style="margin:10px 0 0 0;">
      <div class="col s12 yo-align-right">
         <div @click="docfile = ''" type="alert" class="" style="padding:0 10px;"><i class="material-icons">delete</i></div>
      </div>
      <div class="col s12 yo-align-center">
         <a class="yo-button yo-text-s" :href="previewurl+file.url" target="_blank" >
            <i class="material-icons">cloud_download</i><br />{{file.name}}
         </a>
      </div>
   </div>
   </div>


</div>
</template>

<script>

export default {
   props: ['action','savedir','previewurl','value','extensions'],
   components: {
   },
   created () {
   },
   data () {
      return {
         loading: {},
         docfile: this.value
      }
   },
   watch: {
      docfile: function (val) {
         this.$emit('change', this.docfile)
      }
   },
   computed:{
      file: function(){
         if(typeof this.docfile != 'undefined' && this.docfile!='' && this.docfile!='[]'){
         return JSON.parse(this.docfile)[0]
         }else{
         return {name:'no-file',url:''}
         }
      },
      fileList: function(){
         if(this.docfile!=''){
         return JSON.parse(this.docfile)
         }else{
         return []
         } 
      },
   },
   methods:{
      uploadNow(){
         console.log(arguments)
      },
      onError(e,files, fileList){
         console.log("UPLOAD ERROR")
         this.loading.close()
         this.$alert('Error during uploading file, please try again','UPLOAD ERROR',{type: 'error'})
      },
      onExceed(files, fileList){
         console.log("UPLOAD EXCEED")
         this.loading.close()
         this.$alert(e,'UPLOAD EXCEED',{type: 'error'})
      },
      beforeUpload(file){
         this.loading = this.$loading({
            lock: true,
            text: 'Upload in progress....',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
         })
         console.log(file)
         return true;
      },
      onSuccess(response, file, fileList){
         console.log("UPLOAD SUCCESS")
         console.log(response)
         this.loading.close()

         var filesFilter = []
         var files2save =[]
         for (let fileIn of fileList){
         if(fileIn.name==response.data.original){
            fileIn.url = response.data.filename
            filesFilter.push(fileIn)
            files2save.push({name:fileIn.name,url:fileIn.url})
            break
         }
         }
         fileList = filesFilter
         

         let nameExt = files2save[0].name.split('.').pop()
         //console.log(this.extensions)
         
         if(this.extensions=='' || this.extensions.split(',').indexOf(nameExt.toLowerCase())>-1){
            this.docfile = JSON.stringify(files2save)
            this.$emit('success', this.docfile)
         }else{
            this.$alert('FILE EXTENSION NOT VALID',{type: 'error'})
         }
         
         
      }
   }
}
</script>


// WEBPACK FOOTER //
// Upload.vue?e7bc0460